(function() {
	var paging = function(ctx) {
		var defer;
		var routes;
		var route;
		if ((ctx.params.language === '') || (typeof ctx.params.language == 'undefined')) {
			page('/' + WebBaseAprovLV.lang + '/home');
			return;
		}
		if (typeof ctx.params.page != 'undefined') {
			// Config and initialize Cookie Banner
			(function(ScwCookieIub) {
				var iub;
				if (null !== ScwCookieIub && WebBaseAprovLV.config.cookieiub) {
					WebBaseAprovLV.config.cookieiub.lang = WebBaseAprovLV.lang;
					iub = ScwCookieIub.getInstance();
					iub.init(WebBaseAprovLV.config.cookieiub);
				}
			})('object' === typeof window.ScwCookieIub ? window.ScwCookieIub : null);

			$('#js-page-loading').show();
			// Menu Overlay: Close It
			$('body').removeClass('open');
			$('#sidebar').attr('aria-hidden', 'true');
			$('#menu_btn').attr('aria-expanded', 'false');
			routes = WebBaseAprovLV.RoutingTable.filter(function(item) {
				return item.matches ? item.matches.test(ctx.params.page) : false;
			});
			route = routes.length ? routes[0] : {};
			if (!route.action) {
				route.action = WebBaseAprovLV.renderGenericPage;
			}
			route.action({
				context: ctx
			}).then(function(model) {
				var pageMain = WebBaseAprovLV.Cache.get(['page', WebBaseAprovLV.lang, 'main'].join('.')).value || {};
				var currentUrlSlug = (model.data.pageContent || {}).url || '';
				var currentUrl = currentUrlSlug.length ? [WebBaseAprovLV.lang, currentUrlSlug].join('/') : window.location.pathname;
				var currentNavPath;
				if (!currentUrlSlug.length && currentUrl.length) {
					currentUrlSlug = currentUrl.replace(/.*\/(de|it|lld|en|fr)\//i, '').replace('\/.*', '');
				}
				if (!(model.data || {}).UILangSwitch) {
					model.data = model.data || {};
					model.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
						page: {
							id: ((model.data.pageContent || {}).system_id || '')
						}
					}, $('a.langchange'));
				}

				// navigatoin path (needed for megamenu)
				currentNavPath = (function(nav, currentUrlSlug) {
					var path = [];
					var found = false;
					function pathBuilder_(item) {
						!found && path.push(item);
						if (item.url === currentUrlSlug) {
							found = true;
						};
						if ((item.subpages || []).length) {
							item.subpages.forEach(function(item) {
								pathBuilder_(item);
							});
						}
						!found && path.pop();
						return path;
					}
					return nav ? pathBuilder_(nav) : path;
				})(model.data.main.navroot, currentUrlSlug);

				// create and manage megamenu
				(function(navMain, currentUrlSlug, currentNavPath) {
					var path = currentNavPath.map(function(item) {
						return item.url || '';
					}).filter(function(item) {
						return item.length > 0;
					});
					var htm = [];
					var $mainmenu = $('#sidebarmenu');
					var $clonemenu;
					if ($mainmenu.length && !$mainmenu.metisMenu) {
						return;
					}
					function megamenuBuilder_(item) {
						var subpages = (item.subpages || []).filter(function(subitem) {
							return (!/^no/i.test((subitem.show_in_navigation[0] || {}).codename || ''));
						});
						var hasSubpages = !!subpages.length;
						var isASubpage = false;
						var depthIdx = -1;
						var linkClasses = [];
						var isExternal = (item.external_url || '').length > 0;
						var url = isExternal ? item.external_url : WebBaseAprovLV.Utils.linkTo(['', WebBaseAprovLV.lang, (item.url || '')].join('/'));
						if ((item.show_in_navigation || []).length) {
							if (/^no/i.test((item.show_in_navigation[0] || {}).codename || '')) {
								return;
							}
						};
						if (hasSubpages) {
							linkClasses.push('has-arrow');
							depthIdx = path.indexOf(item.url);
							isASubpage = path.length > 1 && depthIdx > -1 && path.indexOf(currentUrlSlug) > depthIdx;
						}
						if (isExternal) {
							linkClasses.push('external');
						}
						htm.push('<li' + (item.url === currentUrlSlug ? ' class="mm-active"' : '') + '><a ' + (hasSubpages ? ('aria-expanded="' + (isASubpage ? 'true' : 'false') + '" ') : '') + ' class="' + linkClasses.join('\u0020') + '" href="' + (hasSubpages ? 'javascript:void(0);' : url) + '" title="' + (isExternal ? '[external link]': '') + '">' + ((item.navigation_title || '').length ? item.navigation_title : (item.title || '')) + (isExternal ? ' <i class="fa fa-external-link" aria-hidden="true"></i>' : '') + '</a>');
						if (hasSubpages) {
							htm.push('<ul><li><a href="' + url + '"><span class="fa arrow"> </span> ' + WebBaseAprovLV.Utils.gettext('Overview page') + '</a></li>');
							subpages.forEach(function(item) {
								megamenuBuilder_(item);
							});
							htm.push('</ul>');
						}
						htm.push('</li>');
					}
					htm.push('<li><a href="' + WebBaseAprovLV.Utils.linkTo(['', WebBaseAprovLV.lang, 'home'].join('/')) + '" aria-expanded="false">Home</a></li>');
					(navMain || []).forEach(function(item) {
						megamenuBuilder_(item);
					});
					$mainmenu.metisMenu('dispose');
					$clonemenu = $mainmenu.clone(true);
					$clonemenu.html(htm.join(''));
					$mainmenu.empty().replaceWith($clonemenu);
					$mainmenu = $clonemenu;
					if ($mainmenu.length && $mainmenu.metisMenu) {
						$mainmenu.metisMenu();
					}
				})(model.data.main.navroot.subpages || [], currentUrlSlug, currentNavPath);
				$.fn.tooltip && $('[data-toggle=\'tooltip\']').tooltip();
				$.fn.carousel && $('.carousel').carousel();
			}).fail(function() {
				return WebBaseAprovLV.render404();
			}).always(function() {
				$('#js-page-loading').hide();
				// Setup matchheight ajustments
				$('.col_item .card_inner').matchHeight();
				$('.gallery_card').each(function() {
					$(this).find('.card-text').not('.card-text .card-text').matchHeight();
				});
				$('#search_lv_home').matchHeight({
					target: $('.text_box')
				});
				$('.lv_sn_grid').matchHeight();
				// Setup breadcrumb resizing
				function adjustBreadcrumb() {
					$('.lv_crumbs .lv_element').removeClass('lv_brdc_adjusted').attr('style', '');
					var t; var e; var a = $('.lv_crumbs').width();
					var o = $('.lv_crumbs .lv_element').length;
					var n = o - 2;
					var l = 0;
					var c = !1;
					var s = $('.lv_crumbs .lv_element').first().outerWidth();
					var i = $('.lv_crumbs .lv_element').last().outerWidth();
					a / 3 < i && (i = Math.floor(a / 3), c = !0), $('.lv_crumbs .lv_element').each(function(t) {
						$(this).addClass('item_' + t), l += Math.floor($(this).outerWidth());
					}), t = Math.floor(a - (s + i)), e = Math.floor(t / n), 'left' == $('.lv_crumbs .lv_element').css('float') && a <= l && ($('.lv_crumbs .lv_element:gt(0):lt(' + (o - 2) + ')').outerWidth(e).addClass('lv_brdc_adjusted'), c && $('.lv_crumbs .lv_element').last().outerWidth(i).addClass('lv_brdc_adjusted'));
				}
				adjustBreadcrumb();
				$(window).resize(adjustBreadcrumb);
				// Show Cookie Banner
				(function(ScwCookieIub) {
					var iub;
					if (null !== ScwCookieIub) {
						iub = ScwCookieIub.getInstance();
						iub.banner();
					}
				})('object' === typeof window.ScwCookieIub ? window.ScwCookieIub : null);
				if ((WebBaseAprovLV.Utils || {}).ScrollHistory) {
					WebBaseAprovLV.Utils.ScrollHistory.afterRoute(ctx);
				}
			});
		} else {
			page('/' + WebBaseAprovLV.lang + '/home');
		}
	};

	//inizialise pagejs and handle language changes
	page('/:language?/:page?/:detail?', function(ctx) {
		if ((WebBaseAprovLV.Utils || {}).ScrollHistory) {
			WebBaseAprovLV.Utils.ScrollHistory.beforeRoute(ctx);
		}
		// set language
		var languageChanged = false;
		var regexPageParamsById = /system\.id=[\-A-Z0-9a-z]+/i;
		var regexPageParamsByProjectId = /project\.id=[\-A-Z0-9a-z]+/i;
		var newLang = ctx.params.language || '';
		var oldLang = WebBaseAprovLV.lang;
		if (newLang.length && /^(de|it|lld)$/i.test(newLang) && oldLang !== newLang) {
			WebBaseAprovLV.lang = newLang.toLowerCase();
			languageChanged = true;
		}

		// Language switch or opening page by id
		if (regexPageParamsById.test(ctx.params.page || '') || regexPageParamsById.test(ctx.params.detail || '')) {
			WebBaseAprovLV.renderMainContent().then(function(data) {
				if (data.data) {
					// Navigation Tree needed after redirection, so cache it here
					WebBaseAprovLV.Cache.set(['main', WebBaseAprovLV.lang, 'model'].join('.'), data.data);
				}
				$.when.apply($, [ctx.params.page || '', ctx.params.detail || ''].map(function(segment) {
					if (segment.length && regexPageParamsById.test(segment)) {
						if (regexPageParamsByProjectId.test(segment)) {
							var altProjectId = segment.match(regexPageParamsByProjectId)[0];
							return WebBaseAprovLV.Utils.getKKData(['?', segment.match(regexPageParamsById)[0]].join(''), altProjectId.replace('project.id=', ''));
						} else {
							return WebBaseAprovLV.Utils.getKKData(['?', segment.match(regexPageParamsById)[0]].join(''));
						}
					}
					return segment;
				})).then(function(pageData, detailData) {
					var partial = '';
					var item;
					var slug;
					function getUrlslug(item) {
						var urlItem = ['elements', 'url'].reduce(function(acc, cur) {
							return acc && acc[cur];
						}, item);
						if (urlItem && urlItem.type && urlItem.value && /url_slug/i.test(urlItem.type)) {
							return urlItem.value;
						}
						return '';
					}
					if ('string' === typeof pageData) {
						partial = pageData;
					} else if (Array.isArray(pageData) && pageData.length) {
						item = pageData[0].items && pageData[0].items.length ? pageData[0].items[0] : null;
						partial = getUrlslug(item);
					}
					if (partial.length) {
						if ('string' === typeof detailData) {
							if (detailData.length) {
								partial += ('/' + detailData);
							}
						} else if (Array.isArray(detailData) && detailData.length) {
							item = detailData[0].items && detailData[0].items.length ? detailData[0].items[0] : null;
							slug = getUrlslug(item);
							if (slug.length) {
								partial += ('/' + slug);
							}
						}
					} else {
						partial = 'home';
					}
					window.location.href = ['', WebBaseAprovLV.lang, partial].join('/');
				}).fail(function() {
					// something went wrong. Try home
					window.location.href = ['', WebBaseAprovLV.lang, 'home'].join('/');
				});
			});
			return;
		}
		if (languageChanged || $('#content').length === 0) {
			WebBaseAprovLV.renderMainContent().then(function(d) {
				ctx.Model = ctx.Model || {};
				// Add Main ViewModel to context
				ctx.Model.Main = d.data || {};
				// Cache Navigation Tree
				WebBaseAprovLV.Cache.set(['main', WebBaseAprovLV.lang, 'model'].join('.'), ctx.Model.Main);
				$('#sidebar').removeClass('show');	/* Hide Megamenu on page change. Not the elegant and the intelligent way by now, but working. Adjust it later. */
				paging(ctx);
			});
		} else {
			// Get Navigation Tree if it's not just there (after redirection, for example)
			if (!(ctx.Model || {}).Main) {
				ctx.Model = ctx.Model || {};
				// Add Main ViewModel to context
				ctx.Model.Main = WebBaseAprovLV.Cache.get(['main', WebBaseAprovLV.lang, 'model'].join('.')).value || {};
			}
			$('#sidebar').removeClass('show'); /* Hide Megamenu on page change. Not the elegant and the intelligent way by now, but working.  Adjust it later. */
			paging(ctx);
		}
	});

	page({
		hashbang: false /* /dev/i.test(WebBaseAprovLV.config.environment) // Use hashbang in case you can`t set rewrite rules */
	});

})();
